import { CdkMenuModule } from '@angular/cdk/menu';
import { Component, input, signal } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInput } from '../base-input';
import { Input } from '../input.component';
import { InputTimePicker } from './time-picker/time-picker.component';

@Component({
  selector: 'app-input-time',
  templateUrl: './input-time.component.html',
  standalone: true,
  imports: [Input, InputTimePicker, CdkMenuModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputTime,
      multi: true,
    },
  ],
})
export class InputTime extends BaseInput<string> {
  open = signal(false);
  icon = input<string>();

  constructor() {
    super();
  }

  pick(time: string) {
    this.value.set(time);
  }
}
